import { ColumnDef, ColumnPinningState, RowData } from "@tanstack/react-table";
import { useMemo } from "react";

export function getStaticColumnPinning<TData extends RowData>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: ColumnDef<TData, any>[],
) {
  return columns.reduce<ColumnPinningState>((acc, column) => {
    const pinned = column.meta?.pinned;

    const columnId =
      column.id ||
      ("accessorKey" in column && typeof column.accessorKey === "string"
        ? column.accessorKey
        : undefined);

    if (columnId && pinned) {
      if (!acc[pinned]) {
        acc[pinned] = [];
      }
      acc[pinned].push(columnId);
    }

    return acc;
  }, {});
}

export default function useStaticColumnPinning<TData extends RowData>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: ColumnDef<TData, any>[],
) {
  return useMemo(() => getStaticColumnPinning(columns), [columns]);
}
